import { useNavigate } from 'react-router-dom'
import { unitId } from '@/annotations'
import { LauncherCard } from '@/components/LauncherCard'

const CARDS = [
  {
    title: 'General Settings',
    note: 'Enable or disable backups, choose your storage provider, and set your backup window and retention policy.',
    icon: 'i-gear',
    to: '/setgeneral',
  },
  {
    title: 'Repository Inclusion and Exclusion',
    note: 'Specify exactly which of your repositories to include in or exclude from the backup job for granular control over your data.',
    icon: 'i-inout',
    to: '/setrepos',
  },
  {
    title: 'Bitbucket Credential',
    note: 'Securely store the Bitbucket API token that the application needs to authenticate and access your Bitbucket Cloud workspace.',
    icon: 'i-key',
    to: '/credential',
  },
] as const

/**
 * `v-setbackup` — process/09-SCREEN-SPECS/v-setbackup.md, Prototype_v2.html (`div.grid3`, three
 * `card g-blue`: General Settings / Repository Inclusion and Exclusion / API Token — the last
 * retitled here to **Bitbucket Credential** since `settoken` is superseded by `credential`,
 * §27.4 #3). **Rebuilt W174**: the previous shape was a bare bordered list item per card, no
 * colour, no icon, and its own paraphrased description text rather than the prototype's own.
 *
 * **Still carries no `data-act`** — unchanged from before this pass. The spec is explicit that
 * navigation is not an accountable operation here ("an identifier is carried by an operation that
 * mutates state or is an audited egress, and moving between two screens is neither"); see
 * `VAudit`'s own doc comment for the opposite convention on its own two cards, reported rather
 * than forced to agree.
 */
export function VSetbackup() {
  const navigate = useNavigate()
  return (
    <div data-scr={unitId('v-setbackup')}>
      <h1 className="m-0 mb-8 text-section font-semibold">Backup settings</h1>
      <div className="grid gap-8" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(330px, 1fr))' }}>
        {CARDS.map((card) => (
          <LauncherCard key={card.to} variant="blue" icon={card.icon} title={card.title} description={card.note} onClick={() => navigate(card.to)} />
        ))}
      </div>
    </div>
  )
}
